import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NetworkWifi3BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"network_wifi_3_bar"}/>
}
